export default {"src":"/_next/static/media/avatar_dark.6609cd5e.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};